module.exports = __webpack_public_path__ + "img/Cape Verde.d662d647.svg";